import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);

export function GroupProvider({ children }) {
  const [state, setState] = useState(null);
  const [lockerOpen, setLockerOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/case");
      setState(data);
    } catch (e) {
      /* keep last known state; next poll retries */
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 5000);
    return () => clearInterval(t);
  }, [refresh]);

  const markStep = useCallback(async (suspect, step, done = true) => {
    const { data } = await http.post("/case/progress", { suspect, step, done });
    setState(data);
  }, []);

  const value = { state, setState, refresh, markStep, lockerOpen, setLockerOpen };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useGroup = () => useContext(Ctx);
